import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Label } from 'semantic-ui-react';
import '../templates/wizard/iws-templates-wizard.less';

export interface IwsTemplateWizardStepProps extends WithTranslation {
  stepNumber: string;
  stepTitle: string;
  isStepActive: boolean;
}

export interface IwsTemplateWizardStep1State {}

class IwsStepsComponent extends React.Component<IwsTemplateWizardStepProps, IwsTemplateWizardStep1State> {
  constructor(props: IwsTemplateWizardStepProps) {
    super(props);
    this.state = {
      loading: null,
      data: null
    };
  }

  render() {
    const { t, isStepActive } = this.props;

    return (
      <>
        <div className={isStepActive ? 'iws-wizard__label-title flex-start' : 'iws-wizard__label-title flex-start inactive-step'}>
          <Label className="step__label-style" circular>
            {this.props.stepNumber}
          </Label>
          <p className="template-wizard__step-title">{t(this.props.stepTitle)}</p>
        </div>
      </>
    );
  }
}

export default withTranslation()(IwsStepsComponent);
